import { render, staticRenderFns } from "./GroupTree.vue?vue&type=template&id=64d9b905&scoped=true&"
import script from "./GroupTree.vue?vue&type=script&lang=js&"
export * from "./GroupTree.vue?vue&type=script&lang=js&"
import style0 from "./GroupTree.vue?vue&type=style&index=0&id=64d9b905&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9b905",
  null
  
)

export default component.exports